import {Dispatch} from 'react';
import {AccountType} from '../../types/AccountType';
import {AppThunk} from '../rootReducer';

export const LOGGED_IN = 'LOGGED_IN';
export const LOGGED_OUT = 'LOGGED_OUT';

export interface LoggedInUserState {
    requested: boolean,
    loggedIn: boolean,
    userData?: AccountType
}

interface LoginAction {
    type: typeof LOGGED_IN,
    payload: AccountType
}

interface LogoutAction {
    type: typeof LOGGED_OUT;
}

export type LoginActionTypes = LoginAction | LogoutAction;

export const loginAction = (userData: AccountType): AppThunk => {
    return (dispatch: Dispatch<LoginAction>) => {
        return dispatch({
            type: LOGGED_IN,
            payload: userData
        });
    };
};

export const logoutAction = (): AppThunk => (dispatch: Dispatch<LogoutAction>) => {
    return dispatch({
        type: LOGGED_OUT
    });
};
